import axios from '@/axios'

const state = {
    invoicingBatches: [],
    invoicingBatchesCount: 0
};

const getters = {
    getInvoicingBatches: (state) => state.invoicingBatches,
    getInvoicingBatchesCount: (state) => state.invoicingBatchesCount,
};

const actions = {
    async loadInvoicingBatches(context, data) {

        await axios().get(`/getInvoicingBatches`, {
            params: {
                start: data.start,
                per_page: data.perPage,
                is_tester: data.isTester || false,
            }
        })
            .then(response => {
                context.commit('setInvoicingBatches', response.data.invoicing_batches)
                context.commit('setInvoicingBatchesCount', response.data.invoicing_batches_count)
            })
    }
};

const mutations = {
    setInvoicingBatches: (state, invoicingBatches) => (state.invoicingBatches = invoicingBatches),
    setInvoicingBatchesCount: (state, invoicingBatchesCount) => (state.invoicingBatchesCount = invoicingBatchesCount),
};

export default {
    state,
    getters,
    actions,
    mutations
}
